const LOAD_APP_CONFIG = 'LOAD_APP_CONFIG';
const LOAD_SUBMISSION_TYPES = 'LOAD_SUBMISSION_TYPES';
const LOAD_USER_INFO = 'LOAD_USER_INFO';


export { LOAD_APP_CONFIG, LOAD_SUBMISSION_TYPES, LOAD_USER_INFO };



// WEBPACK FOOTER //
// ./src/redux/actionTypes.js